export default __webpack_public_path__ + "images/icon-chevron.png?507b0bfeb32d299b2dbfae1a647409f9";